import { Box, Button, Text } from '@csscompany/csds-components';
import { rosetta } from '@csscompany/op-facility-finder';
import { isBrowser } from '@publicss/utils';
import copy from 'copy-to-clipboard';
import React from 'react';

import { Button as CKButton } from '../ui';

type MobileCopySaveProps = {
  facilityName: string;
};

export const MobileCopySave = ({
  facilityName,
}: MobileCopySaveProps): JSX.Element => {
  const navigator = window.navigator;
  const shareUrl = new URL(
    isBrowser() ? window.location.href : 'https://cloudkitchens.com/locations/'
  );
  shareUrl.searchParams.append('utm_content', 'ff-details-cta');
  shareUrl.searchParams.append('utm_source', 'ff-details-page');
  shareUrl.searchParams.append('utm_medium', 'share');

  const shareData: ShareData = {
    title: facilityName,
    text: facilityName,
    url: shareUrl.toString(),
  };

  return (
    <Box
      id="sticky-book-tour"
      style={{ height: '44px' }}
      display="grid"
      gridTemplateColumns="1fr 1fr"
      gap="$2">
      <Button
        shape="round"
        onClick={() => {
          if (
            navigator &&
            navigator.canShare !== undefined &&
            navigator.share !== undefined &&
            navigator.canShare(shareData)
          ) {
            navigator.share(shareData);
          } else {
            copy(shareUrl.toString());
          }
        }}
        variant="primary"
        emphasis="medium">
        <Text style={{ textTransform: 'uppercase' }}>
          {rosetta.share.getText()}
        </Text>
      </Button>
      <CKButton globalTypeform fullWidth utm_content="ff-details-cta">
        <Text variant="$labelSmallBold">
          {rosetta.facility_card_book_tour_button.getText()}
        </Text>
      </CKButton>
    </Box>
  );
};
